const escapeIcs = x =>
  String(x).replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;')

const toIso8601 = x => x.replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z')

export const googleCalendarUrl = ({ title, description, startsAt, endsAt, url }) => {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    dates: `${toIso8601(startsAt)}/${toIso8601(endsAt)}`,
    details: `${description}\n\nLink: ${url}`.trim(),
    location: url,
    text: title,
  })

  return `https://calendar.google.com/calendar/render?${params.toString()}`
}

export const appleCalendarUrl = ({ id, title, description, startsAt, endsAt, url }) => {
  let domain = 'localhost'

  try {
    domain = new URL(url).hostname || domain
  } catch {
    /* empty */
  }

  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    `PRODID:-//${domain}//PostToCalendar//EN`,
    'BEGIN:VEVENT',
    `UID:${id || Date.now()}@${domain}`,
    `DTSTAMP:${toIso8601(new Date().toISOString())}`,
    `DTSTART:${toIso8601(startsAt)}`,
    `DTEND:${toIso8601(endsAt)}`,
    `SUMMARY:${escapeIcs(title)}`,
    `DESCRIPTION:${escapeIcs(`${description}\\n\\nLink: ${url}`)}`,
    `URL:${escapeIcs(url)}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n')

  return `data:text/calendar;charset=utf-8,${encodeURIComponent(ics)}`
}

const outlookCalendarUrl = ({ title, description, startsAt, endsAt, url }, host) => {
  const params = new URLSearchParams({
    body: `${description}\n\nLink: ${url}`.trim(),
    enddt: endsAt,
    location: url,
    path: '/calendar/action/compose',
    rru: 'addevent',
    startdt: startsAt,
    subject: title,
  })

  return `https://${host}/calendar/0/deeplink/compose?${params.toString()}`
}

export const outlookLiveUrl = x => outlookCalendarUrl(x, 'outlook.live.com')
export const outlookOfficeUrl = x => outlookCalendarUrl(x, 'outlook.office.com')
